// Mirrors server/utils/tripTime.js so the form can warn early. The server
// re-checks on checkout and is the authority.
const TIME_ZONE = "Africa/Cairo";
export const VERIFICATION_LEAD_MS = 48 * 60 * 60 * 1000;

const cairoOffsetMs = (instantMs) => {
  const parts = Object.fromEntries(
    new Intl.DateTimeFormat("en-US", {
      timeZone: TIME_ZONE, hourCycle: "h23",
      year: "numeric", month: "2-digit", day: "2-digit",
      hour: "2-digit", minute: "2-digit", second: "2-digit",
    }).formatToParts(new Date(instantMs)).map((p) => [p.type, p.value])
  );
  const asUtc = Date.UTC(parts.year, parts.month - 1, parts.day, parts.hour, parts.minute, parts.second);
  return asUtc - instantMs;
};

export const cairoDateTime = (dateStr, timeStr = "00:00") => {
  const [y, mo, d] = String(dateStr).split("-").map(Number);
  const [h, mi] = String(timeStr).split(":").map(Number);
  if (!y || !mo || !d) return null;
  const naive = Date.UTC(y, mo - 1, d, h || 0, mi || 0);
  return new Date(naive - cairoOffsetMs(naive));
};

export const meetsVerificationLeadTime = (start) =>
  !!start && start.getTime() - Date.now() >= VERIFICATION_LEAD_MS;

// Earliest date (YYYY-MM-DD, Cairo) that can possibly satisfy the lead time
export const earliestVerifiedDate = () => {
  const target = new Date(Date.now() + VERIFICATION_LEAD_MS);
  return new Intl.DateTimeFormat("en-CA", { timeZone: TIME_ZONE }).format(target);
};
